(function () {
  const SECTION_ORDER = [
    'intro',
    'includes',
    'pyramid',
    'inspiration',
    'ingredient',
    'ingredients',
    'functions',
    'fragances',
    'fragancess',
    'features',
    'smell',
    'recommended',
    'usage',
    'why'
  ];

  const ACCORDION_SECTIONS = ['includes', 'pyramid', 'inspiration', 'ingredient', 'ingredients', 'functions', 'fragances', 'fragancess', 'features', 'smell'];

  const TITLES = {
    includes: '¿Qué incluye?',
    pyramid: 'Pirámide olfativa',
    inspiration: 'Inspiración olfativa',
    ingredient: 'Ingrediente destacado',
    ingredients: 'Ingredientes destacados',
    functions: null,
    fragances: 'Fragancias disponibles',
    fragancess: 'Aromas disponibles',
    features: 'Características',
    smell: '¿A qué huele?',
    recommended: '¿Para quién está recomendado?',
    usage: 'Modo de empleo',
    why: '¿Por qué comprar en Laureia Shop?'
  };

  function getSectionTitle(key) {

  const product = productTitle();

  switch (key) {

    case 'functions':
      return `¿Qué hace ${product}?`;

    case 'inspiration':
      return `Pirámide olfativa`;

    default:
      return TITLES[key];
  }

}

function productTitle() {
  const title =
    document.querySelector('.product__title h2') ||
    document.querySelector('h2.product__title') ||
    document.querySelector('h2');

  if (!title) return 'este producto';

  return title ? title.textContent.split(/\s*[-–—|]\s*/)[0].trim() : 'este producto';
}

  const TICK_RE = /^[\s✓✔✅âœ”]+/i;

  function fixText(text) {
    return text
      .replace(/Ã¡/gi, 'á')
      .replace(/Ã©/gi, 'é')
      .replace(/Ã­/gi, 'í')
      .replace(/Ã³/gi, 'ó')
      .replace(/Ãº/gi, 'ú')
      .replace(/Ã±/gi, 'ñ')
      .replace(/Ã/g, 'Á')
      .replace(/Ã‰/g, 'É')
      .replace(/Ã/g, 'Í')
      .replace(/Ã“/g, 'Ó')
      .replace(/Ãš/g, 'Ú')
      .replace(/Ã‘/g, 'Ñ')
      .replace(/Â/g, '')
      .replace(/âœ”/gi, '✔');
  }

  function cleanSpaces(text) {
    return text.replace(/\s+/g, ' ').trim();
  }

  function normalize(text) {
    return fixText(text)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[¿?]/g, '')
      .replace(/[.:]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function nodeText(node) {
    return cleanSpaces(fixText(node.textContent || ''));
  }

  function sectionKeyFromText(text) {
    const value = normalize(text);

    if (value.includes('que incluye')) return 'includes';
    if (value.includes('caracteristicas')) return 'features';
    if (value.indexOf('ingrediente destacado') === 0) return 'ingredient';
    if (value.indexOf('ingredientes destacados') === 0) return 'ingredients';
    if (value.indexOf('que hace') === 0) return 'functions';
    if (value.indexOf('piramide olfativa') === 0) return 'pyramid';
    if (value.indexOf('piramides olfativas') === 0) return 'pyramid';
    if (value.indexOf('inspiracion olfativa') === 0) return 'inspiration';
    if (value.includes('fragancias disponibles')) return 'fragances';
    if (value.includes('aromas disponibles')) return 'fragances';
    if (value.indexOf('a que huele') === 0) return 'smell';
    if (value === 'para quien esta recomendado') return 'recommended';
    if (value === 'modo de empleo') return 'usage';
    if (value === 'por que comprar en laureia shop') return 'why';

    return null;
  }

  function hasContent(nodes) {
    return nodes.some(function (node) {
      return nodeText(node) || (node.querySelector && node.querySelector('img, video, iframe, table'));
    });
  }

  function collectSections(container) {
    const sections = { intro: [] };
    let currentKey = 'intro';

    Array.from(container.childNodes).forEach(function (node) {
      const key = sectionKeyFromText(nodeText(node));

      if (key) {
        currentKey = key;
        sections[currentKey] = sections[currentKey] || [];
        return;
      }

      sections[currentKey] = sections[currentKey] || [];
      sections[currentKey].push(node.cloneNode(true));
    });

    return sections;
  }

  function removeLeadingTickFromElement(element) {
    if (!TICK_RE.test(nodeText(element))) return;

    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let textNode = walker.nextNode();

    while (textNode) {
      if (textNode.nodeValue.trim()) {
        textNode.nodeValue = fixText(textNode.nodeValue).replace(TICK_RE, '').trimStart();
        return;
      }

      textNode = walker.nextNode();
    }
  }

  function makeListItem(html) {
    const item = document.createElement('li');
    item.innerHTML = html.replace(TICK_RE, '').trim();
    removeLeadingTickFromElement(item);
    return item;
  }

  function paragraphTickList(paragraph) {
    const html = paragraph.innerHTML.replace(/âœ”/gi, '✔');

    if (!/[✓✔✅]/.test(html)) return null;

    const pieces = html
      .split(/<br\s*\/?>/i)
      .map(function (piece) {
        return piece.trim();
      })
      .filter(function (piece) {
        return piece && /[✓✔✅]/.test(piece);
      });

    if (pieces.length < 2) return null;

    const list = document.createElement('ul');
    list.className = 'laureia-description__list';

    pieces.forEach(function (piece) {
      list.appendChild(makeListItem(piece));
    });

    return list;
  }

  function cleanLists(container) {
    Array.from(container.querySelectorAll('ul')).forEach(function (list) {
      list.classList.add('laureia-description__list');

      Array.from(list.children).forEach(function (item) {
        removeLeadingTickFromElement(item);
      });
    });

    Array.from(container.querySelectorAll('p')).forEach(function (paragraph) {
      const list = paragraphTickList(paragraph);

      if (list) {
        paragraph.replaceWith(list);
      }
    });
  }

  function plainTextElement(text, className) {
    const element = document.createElement('p');
    element.className = className;
    element.textContent = text;
    return element;
  }

  function noteHeadingText(text) {
    const value = normalize(text);

    if (value === 'notas salida' || value === 'notas de salida') return 'Notas de salida';
    if (value === 'notas corazon' || value === 'notas de corazon') return 'Notas de corazón';
    if (value === 'notas fondo' || value === 'notas de fondo') return 'Notas de fondo';

    return null;
  }

  function perfumeTitleFromText(text) {
    return cleanSpaces(text)
      .replace(/\s*\([^)]*\)\s*$/, '')
      .replace(/\s*[.:]+$/, '')
      .trim();
  }

  function makeDetails(title, className) {
    const details = document.createElement('details');
    const summary = document.createElement('summary');

    details.className = className;
    summary.className = 'laureia-description__summary';
    summary.textContent = title;

    details.appendChild(summary);

    return details;
  }

  function createContent(nodes) {
    const content = document.createElement('div');
    content.className = 'laureia-description__content';

    nodes.forEach(function (node) {
      const fixedNoteTitle = noteHeadingText(nodeText(node));

      if (fixedNoteTitle) {
        content.appendChild(plainTextElement(fixedNoteTitle, 'laureia-description__note-title'));
      } else {
        content.appendChild(node);
      }
    });

    cleanLists(content);

    return content;
  }

  function newOlfactoryBlock(title) {
    return {
      title: perfumeTitleFromText(title),
      nodes: []
    };
  }

  function appendContentNode(state, currentBlock, flatNodes, node) {
    if (currentBlock && state !== 'waiting') {
      currentBlock.nodes.push(node);
    } else {
      flatNodes.push(node);
    }
  }

  function appendPendingNode(flatNodes, pendingNode) {
    if (!pendingNode) return;

    if (pendingNode.block && pendingNode.state !== 'waiting') {
      pendingNode.block.nodes.push(pendingNode.node);
    } else {
      flatNodes.push(pendingNode.node);
    }
  }

  function buildPyramidContent(nodes) {
    const wrapper = document.createElement('div');
    wrapper.className = 'laureia-description__content';

    const blocks = [];
    const flatNodes = [];
    let state = 'waiting';
    let currentBlock = null;
    let pendingTitle = null;

    function addNode(targetState, node) {
      appendContentNode(targetState, currentBlock, flatNodes, node);
    }

    function flushPendingTitle() {
      if (!pendingTitle) return;

      if (pendingTitle.block) {
        pendingTitle.block.nodes.push(pendingTitle.node);
      } else {
        flatNodes.push(pendingTitle.node);
      }

      pendingTitle = null;
    }

    nodes.forEach(function (node) {
      const text = nodeText(node);
      const noteTitle = noteHeadingText(text);

      if (noteTitle) {
        if (noteTitle === 'Notas de salida') {
          state = 'salida';

          if (pendingTitle) {
            currentBlock = newOlfactoryBlock(nodeText(pendingTitle.node));
            blocks.push(currentBlock);
            pendingTitle = null;
          }
        } else {
          flushPendingTitle();
          state = noteTitle === 'Notas de corazón' ? 'corazon' : 'fondo';
        }

        addNode(state, node);
        return;
      }

      if (!text) {
        addNode(state, node);
        return;
      }

      flushPendingTitle();
      pendingTitle = { node: node, block: currentBlock };

      if (state === 'fondo') {
        state = 'waiting';
      }
    });

    flushPendingTitle();

    if (blocks.length < 2) {
      return createContent(nodes);
    }

    if (hasContent(flatNodes)) {
      Array.from(createContent(flatNodes).childNodes).forEach(function (node) {
        wrapper.appendChild(node);
      });
    }

    blocks.forEach(function (block) {
      const details = makeDetails(block.title, 'laureia-description__nested-accordion');
      details.appendChild(createContent(block.nodes));
      wrapper.appendChild(details);
    });

    return wrapper;
  }

  function firstBoldTitle(item) {
    const bold = item.querySelector('b, strong');

    if (!bold) return '';

    const title = nodeText(bold);
    const beforeBold = item.textContent.slice(0, item.textContent.indexOf(bold.textContent));

    if (beforeBold.trim()) return '';

    return perfumeTitleFromText(title);
  }

  function removeFirstBold(element) {
    const bold = element.querySelector('b, strong');

    if (!bold) return;

    const parent = bold.parentNode;
    bold.remove();

    if (parent && !nodeText(parent)) {
      parent.remove();
    }
  }

  function smellListToDetails(list) {
    const items = Array.from(list.children);
    const titles = items.map(firstBoldTitle);

    if (!items.length || titles.some(function (title) { return !title; })) {
      return null;
    }

    const fragment = document.createDocumentFragment();

    items.forEach(function (item, index) {
      const details = makeDetails(titles[index], 'laureia-description__nested-accordion');
      const content = document.createElement('div');
      const copy = item.cloneNode(true);

      content.className = 'laureia-description__content';
      removeFirstBold(copy);
      content.innerHTML = copy.innerHTML.trim();
      cleanLists(content);

      details.appendChild(content);
      fragment.appendChild(details);
    });

    return fragment;
  }

  function buildSmellContent(nodes) {
    const content = createContent(nodes);

    Array.from(content.querySelectorAll('ul')).forEach(function (list) {
      const details = smellListToDetails(list);

      if (details) {
        list.replaceWith(details);
      }
    });

    return content;
  }

  function createSection(key, nodes) {
    const isAccordion = ACCORDION_SECTIONS.indexOf(key) !== -1;
    const section = isAccordion
      ? makeDetails(getSectionTitle(key), 'laureia-description__accordion laureia-description__section-- h4 laureia-description__title' + key)
      : document.createElement('section');

    let content;

    if (!isAccordion) {
      section.className = 'laureia-description__section laureia-description__section--' + key;
    }

    if (key !== 'intro' && !isAccordion) {
      const title = document.createElement('h2');
      title.className = 'h4 laureia-description__title';
      title.textContent = getSectionTitle(key);
      section.appendChild(title);
    }

    if (key === 'pyramid') {
      content = buildPyramidContent(nodes);
    } else if (key === 'smell') {
      content = buildSmellContent(nodes);
    } else {
      content = createContent(nodes);
    }

    section.appendChild(content);

    return section;
  }

  function render(container) {
    if (container.dataset.laureiaReady === 'true') return;

    const sections = collectSections(container);
    const fragment = document.createDocumentFragment();

    SECTION_ORDER.forEach(function (key) {
      const nodes = sections[key];

      if (!nodes || !hasContent(nodes)) return;

      fragment.appendChild(createSection(key, nodes));
    });

    container.innerHTML = '';
    container.appendChild(fragment);
    container.dataset.laureiaReady = 'true';
  }

  function init() {
    document.querySelectorAll('.laureia-description').forEach(render);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
